export const questions: {
  title: string
  answers: (
    | {
        title: string
        costAndMultiplier: number[]
        cost?: undefined
        costMultiplier?: undefined
      }
    | {
        title: string
        cost: number
        costAndMultiplier?: undefined
        costMultiplier?: undefined
      }
    | {
        title: string
        cost?: undefined
        costAndMultiplier?: undefined
        costMultiplier: number
      }
  )[]
}[] = [
  {
    title: 'Qual a qualidade que procura que o seu site tenha?',
    answers: [
      {
        title: 'Topo de gama',
        costMultiplier: 1.3,
      },
      {
        title: 'Boa',
        costMultiplier: 1,
      },
      {
        title: 'Mínimo necessário',
        costMultiplier: 0.7,
      },
    ],
  },
  {
    title: 'Quantas páginas com estrutura distinta deverá ter o seu site?',
    answers: [
      {
        title: '10+',
        cost: 2000,
      },
      {
        title: '6-9',
        cost: 1600,
      },
      {
        title: '3-5',
        cost: 1200,
      },
      {
        title: '1-2',
        cost: 800,
      },
    ],
  },
  {
    title: 'Qual o tipo de design que deseja para o seu site?',
    answers: [
      {
        title: 'Design único e criativo',
        costMultiplier: 2,
      },
      {
        title: 'Design customizado simples',
        costMultiplier: 1.5,
      },
      {
        title: 'Design baseado num template',
        costMultiplier: 1.5,
      },
      {
        title: 'Sem design',
        costMultiplier: 1,
      },
    ],
  },
  {
    title: 'Que tipo de login deve suportar o seu site?',
    answers: [
      {
        title: 'Email',
        costAndMultiplier: [1000, 1.1],
      },
      {
        title: 'Redes Sociais',
        costAndMultiplier: [700, 1.1],
      },
      {
        title: 'Email e Redes Sociais',
        costAndMultiplier: [1400, 1.1],
      },
      {
        title: 'Nenhum',
        cost: 0,
      },
      {
        title: 'Outro / Não sei',
        costMultiplier: 1.1,
      },
    ],
  },
  // {
  //   title: 'Os seus utilizadores devem poder criar um perfil público?',
  //   answers: [
  //     {
  //       title: 'Sim',
  //       cost: 1000,
  //     },
  //     {
  //       title: 'Não',
  //       cost: 0,
  //     },
  //     {
  //       title: 'Não sei',
  //       costMultiplier: 1.1,
  //     },
  //   ],
  // },
  {
    title: 'O seu site inclui um blog ou uma secção de notícias?',
    answers: [
      {
        title: 'Sim',
        costAndMultiplier: [600, 1.1],
      },
      {
        title: 'Não',
        cost: 0,
      },
    ],
  },
  {
    title: 'O seu site permitirá a realização de pagamentos?',
    answers: [
      {
        title: 'Sim, para compra de produtos',
        costAndMultiplier: [2200, 1.2],
      },
      {
        title: 'Sim, para subscrição de serviços',
        costAndMultiplier: [1900, 1.2],
      },
      {
        title: 'Não, há apresentação de produtos, mas sem venda',
        costAndMultiplier: [1500, 1.1],
      },
      {
        title: 'Não há venda ou apresentação de produtos',
        cost: 0,
      },
    ],
  },
  {
    title: 'Necessita de backoffice para gestão de conteúdos?',
    answers: [
      {
        title: 'Sim',
        costMultiplier: 1.1,
      },
      {
        title: 'Não',
        costMultiplier: 1,
      },
      {
        title: 'Não sei',
        costMultiplier: 1.1,
      },
    ],
  },
  {
    title: 'Quantas línguas deve suportar o seu site?',
    answers: [
      {
        title: 'Uma única língua',
        cost: 0,
      },
      {
        title: 'Duas línguas',
        costAndMultiplier: [500, 1.1],
      },
      {
        title: 'Mais de duas línguas',
        costAndMultiplier: [700, 1.1],
      },
    ],
  },
  // {
  //   title: 'Irá existir alguma app integrada com o seu site?',
  //   answers: [
  //     {
  //       title: 'Sim',
  //       costAndMultiplier: [600, 1.1],
  //     },
  //     {
  //       title: 'Não',
  //       cost: 0,
  //     },
  //     {
  //       title: 'Não sei',
  //       costMultiplier: 1.1,
  //     },
  //   ],
  // },
  {
    title: 'Necessita de produção de conteúdos (texto, imagens ou vídeo)?',
    answers: [
      {
        title: 'Sim, para grande parte do conteúdo',
        costAndMultiplier: [600, 1.2],
      },
      {
        title: 'Sim, para uma pequena parte do conteúdo',
        cost: 300,
      },
      {
        title: 'Não',
        cost: 0,
      },
    ],
  },
]
